module.exports = __webpack_public_path__ + "static/toast-criticalaction-dont-cb2a832b7532e3615b2718b22f6acb86.png";